import { render, staticRenderFns } from "./CustomisableCaseDetails.vue?vue&type=template&id=4389d29e&scoped=true&"
import script from "./CustomisableCaseDetails.vue?vue&type=script&lang=js&"
export * from "./CustomisableCaseDetails.vue?vue&type=script&lang=js&"
import style0 from "./CustomisableCaseDetails.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CustomisableCaseDetails.vue?vue&type=style&index=1&id=4389d29e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4389d29e",
  null
  
)

export default component.exports